import { render, staticRenderFns } from "./ChangeBattery.vue?vue&type=template&id=7024e95c"
import script from "./ChangeBattery.vue?vue&type=script&lang=js"
export * from "./ChangeBattery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports